export const cursorPositions = {
  CENTER: 'center',
  UPPER_LEFT: 'upperLeft',
  UPPER_RIGHT: 'upperRight',
  LOWER_LEFT: 'lowerLeft',
  LOWER_RIGHT: 'lowerRight',
};
